import { useState, useEffect , useContext } from "react";
import "./Blog.css";
import axios from "axios";
import { useParams } from "react-router-dom";
import { API_BASE_URL, IMAGES_BASE_URL } from "../../api/config";
import { useTranslateKey } from "../../components/translation/useTranslateKey";
import { LangContext } from "../../components/translation/langugeContext";

const BlogDetails = () => {

  const { id } = useParams();
  const [blog, setBlog] = useState({});
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/blog-detail/${id}/`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
      .then((response) => {
        console.log(response.data);
        setBlog(response.data);
      })
      .catch((error) => {
        if (error.response) {
          console.log("Server responded:", error.response);
        } else if (error.request) {
          console.log("Request made but no response:", error.request);
        } else {
          console.log("Error setting up request:", error.message);
        }
      });
  }, [id]);

  return (
    <>
      <section id="property-details" className="bg-[#11132F] text-white">
        {/* Main Content */}
        <div
          className="container mx-auto px-4"
          style={{ paddingTop: " -70px" }}
        >
          {/* blog-gallery */}
          <div className="blog-gallery mb-12">
            <div className="main-image relative h-96 rounded-xl overflow-hidden mb-4">
              <img
                src={`${IMAGES_BASE_URL}${blog.image}`}
                alt={blog.title ? blog.title : "Blog visual"}
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          {/* Blog Content */}
          <div className="Blog-Content gap-8">
            {/* Main Content */}
            <div>
              <BlogInfoCard blog={blog} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

// Blog Info Card Component
const BlogInfoCard = ({ blog }) => {
  const { lang } = useContext(LangContext);
  const t = useTranslateKey();
  // Helper to format date with English day/year and Arabic month if lang === "ar"
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    if (lang === "ar") {
      // Get English day and year
      const day = date.toLocaleDateString("en-US", { day: "2-digit" });
      const year = date.toLocaleDateString("en-US", { year: "numeric" });
      // Get Arabic month
      const month = date.toLocaleDateString("ar-EG", { month: "short" });
      return `${day} ${month} ${year}`;
    } else {
      // Default: en-US full
      return date.toLocaleDateString("en-US", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    }
  };

  return (
    <div className="Blog-info-card backdrop-blur-lg p-8 rounded-xl bg-white/5 border border-white/10">
      <h1 className="text-3xl font-bold text-white mb-6">
        {lang === "ar" ? blog.title_ar || blog.title : blog.title}
      </h1>
      <div className="flex flex-wrap items-center gap-6 text-gray-300 mb-8">
        <div className="blog-meta">
          <span>
            <i className="far fa-calendar"></i>{" "}
            {formatDate(blog.created_at)}
          </span>
          <span>
            <i className="far fa-clock"></i> {blog.read_time} {t("min")}
          </span>
        </div>
      </div>

      {/* Description */}
      <div className="border-t border-white/10 pt-8">
        <h2 className="text-2xl font-bold text-accent-yellow mb-6">
          {t("description")}
        </h2>
        <div className="space-y-6">
          <div className="text-gray-300 text-lg leading-relaxed">
            {lang === "ar" ? blog.content_ar || blog.content : blog.content}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetails;
